import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import id from "./locales/id.json";
import type { Messages } from "./messages";

/** Ensure JSON bundles match the UI `Messages` shape (compile-time check). */
const resources = {
  en: { translation: en as Messages },
  id: { translation: id as Messages },
} as const;

export const initI18nPromise = i18next.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18next;
